export default __webpack_public_path__ + "19d1a2c0e79cee3357a246f4dcc4d4a1.png";